import React from "react";
import "./GetInTouch.css";
import Girl from "../../../../assets/images/getintouch-girl.png";
import Dots from "../../../../assets/images/getintouch-dots.png";
const GetInTouch = () => {
  return (
    <div className="getintouch__section">
      {/* <div className="getintouch__section_bg">
        <div className="getintouch__secbg_eclipse1">555555555555555555555</div>
        <div className="getintouch__secbg_eclipse2"></div>
        <div className="getintouch__secbg_eclipse3"></div>
      </div> */}
      <img src={Dots} alt="" className="getintouch__section_dots" />
      <div className="getintouch__section_content">
        <div className="getintouch__section_cntleft">
          <div className="getintouch__section_clheading">
            We are optimists who love to work{" "}
            <span className="getintouch__section_clhgreen">Together</span>
          </div>
          <button className="getintouch__section_clbtn">Get In Touch</button>
        </div>
        <div className="getintouch__section_cntright">
          <img src={Girl} alt="" className="getintouch__section_crimg" />
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
